import { useLogger } from '../composables/useLogger'
import { useAuthStore } from '../stores/authStore'

export default defineNuxtPlugin(async (nuxtApp) => {
  const logger = useLogger()
  const authStore = useAuthStore()
  
  // Initialize auth state on app start
  try {
    logger.debug("Auth Plugin: initializing auth state")
    await authStore.checkAuth()
    logger.debug("Auth Plugin: auth state initialized")
  } catch (error) {
    logger.logErrorCaught('Failed to initialize auth state', 'Auth.ts', error)
  }
}) 